interface Params {
  firm: string | undefined;
  series: string | undefined;
  allocation: string | undefined;
}

const constructFamilyPath = ({
  firm,
  series,
  allocation,
}: Params): string | undefined => {
  if (firm === undefined || series === undefined || allocation === undefined) {
    return undefined;
  }

  const [allocation1, allocation2] = allocation.split("/");

  const familyPathAllocation =
    allocation1 && allocation2
      ? `${allocation1}\\/${allocation2}`
      : allocation1; // if allocation is a string, allocation1 should always be a string

  return `${firm}/${series}/${familyPathAllocation}`;
};

export default constructFamilyPath;
